<nav id="navbar" class="navbar navbar-expand-lg navbar-light background-secondary brown">
  <div class="container-fluid m-0">
    <a class="" href="#">
      <img class="navbar-img" src="assets/logo.jpeg" alt="" width="120" height="40">  
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item" [routerLinkActive]="['active','background-primary']" (click)="navigateToHome()">
          <a class="nav-link brown" [routerLink]="'home'" aria-current="page" href="#">Home</a>
        </li>
        <li class="nav-item" [routerLinkActive]="['active','background-primary']" (click)="navigateToProducts();" > 
          <a class="nav-link brown" [routerLink]="'products'" href="#" tabindex="-1" aria-disabled="true">Productos</a>
        </li>
      </ul>
      <!-- <form class="d-flex" [formGroup]="form" (ngSubmit)="search()">
        <input class="form-control me-2 navbar-expand" type="search" placeholder="¿Que necesitas?" formControlName="searchValue" aria-label="Search">
        <button class="btn background-primary brown" type="submit">Buscar</button>
      </form> -->
      <app-cart-modal></app-cart-modal>
    </div>
  </div>
</nav>